
import { Footer } from "../../../features/footer/footer";
import { JobCategories } from "../../../features/jobCategories/jobCategories";
import LatestJobList from "../../../features/jobList/LatestJobList/LatestJobList";
import JobRoles from "../../../features/JobRoles/JobRoles";
import { JobSearch } from "../../../features/jobSearch/jobSearch";
import { OurApp } from "../../../features/news&locations/installApp";
import { Testimonials } from "../../../features/testimonials/testimonials";
import TopCompanies from "../../../features/TopCompanies/TopCompanies";

export function Home() {
  // const token = useSelector(selectToken)
  // const [isLogin, setIsLogin] = useState(false)
  // useEffect(() => {
  //     if(token){
  //         setIsLogin(true)
  //     }
  // }, [token])
  return (
    <div
      style={{
        background: "linear-gradient(90deg, rgba(119, 161, 211, 0.2), rgba(121, 203, 202, 0.05), rgba(254, 234, 234, 0.3))",
      }}

    >
      {/* <Dummy /> */}
      <JobSearch />
      <JobCategories />
      <TopCompanies />
      <LatestJobList />
      <JobRoles />



      <Testimonials />
      {/* <TopCompanies/> */}
      <OurApp />
      {/* <TopJobs /> */}
      {/* <News/> */}
      <Footer />
    </div>
  );
}
